export const referentielSelector = (state) => state.referentiel.version;